const apiUrl = 'https://www.yay.com';

export type ApiPostResponseItem = {
  article_title: string;
  url_key: string;
  publish_on: string;
  author_name: string;
  author_avatar: string;
  type_id: number;
  url?: string;
  read_time: number;
};

export type ApiReviewsResponse = {
  average: string;
  total: string;
  five_start_count: string;
  comments: {
    review: string;
    author: string;
  }[];
};

export const apiContent = {
  getReviews: async () => {
    const response = await fetch(`${apiUrl}/api/reviews`, {
      cache: 'no-cache',
    });
    // Removed caching from reviews API call at request of marketing team
    const data: ApiReviewsResponse = await response.json();
    return data;
  },
  getPosts: async () => {
    const response = await fetch(`${apiUrl}/svc/content-articles/?limit=12`);
    const data = await response.json();
    const content: ApiPostResponseItem[] = data.result;
    return content;
  },
};
